"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => {
  var _theme$palette;
  return {
    content: {
      background: (_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.grey) === null || _theme$palette === void 0 ? void 0 : _theme$palette[50],
      padding: theme.spacing(3)
    }
  };
});
var _default = exports.default = styles;